import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    AssetTypeDto, AssetTypePaginator,
    CreateAssetTypeDto,
    QueryAssetTypeDto,
    SearchAssetTypeDto,
    UpdateAssetTypeDto
} from "../models/assets-type.dto";
import ENDPOINTS from "./utils/endpoints";
import {QueryOptionsDto} from "../models/generic.dto";

export function useGetAssetsType(options?: QueryAssetTypeDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.ASSETS_TYPE.GET;
    const request = (options: QueryAssetTypeDto) => API.ProcessingCompanyAPI.getAssetsType(options);

	const { data, isLoading, error, refetch } = useQuery<AssetTypePaginator, Error>(
		[url, options],
		({ queryKey, pageParam }) =>
			request(Object.assign({}, queryKey[1], pageParam)),
		{...API.Handlers.pageParamOption}
	);

	return { data, isLoading, error, refetch };
}

export function useSearchAssetsType(options?: SearchAssetTypeDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.ASSETS_TYPE.SEARCH;
    const request = (options: SearchAssetTypeDto) => API.ProcessingCompanyAPI.searchAssetsTypes(options);

	const { data, isLoading, error, refetch } = useQuery<AssetTypePaginator, Error>(
		[url, options],
		({ queryKey, pageParam }) =>
			request(Object.assign({}, queryKey[1], pageParam)),
		{...API.Handlers.pageParamOption}
	);

	return { data, isLoading, error, refetch };
}

export function useGetAssetsTypeById(id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.ASSETS_TYPE.DETAIL;
    const request = API.ProcessingCompanyAPI.getAssetsTypeById(id);

    const {data, isLoading, error} = useQuery<{ data: AssetTypeDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateAssetsType() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload}: {payload: CreateAssetTypeDto}) => API.ProcessingCompanyAPI.createAssetsType(payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.ASSETS_TYPE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateAssetsType() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, id}: {payload: UpdateAssetTypeDto, id: number}) => API.ProcessingCompanyAPI.updateAssetsType(id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.ASSETS_TYPE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteAssetType() {
    
    return useMutation(
        ({ id}: {id: number}) => API.ProcessingCompanyAPI.deleteAssetsTypeById(id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}